import type { UserSettings } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { SETTINGS_API_ROOT } from '../constants';

export function getUserSettings(): Promise<UserSettings> {
  return FetchPromise.get(SETTINGS_API_ROOT);
}

export function useGetUserSettingsQuery() {
  return useQuery<UserSettings, JQuery.jqXHR>(['settings'], () => getUserSettings(), {});
}
